/* eslint-disable react/prop-types */
import Flag from '@atlaskit/flag';
import SuccessIcon from '@atlaskit/icon/glyph/check-circle';
import { token } from '@atlaskit/tokens';
import { FlagComponentProps } from './FlagTypes';

const UnlinkAccountSuccessFlag: React.FC<FlagComponentProps> = ({
  onDismiss,
}) => {
  return (
    <Flag
      icon={
        <SuccessIcon
          label="Success"
          size="medium"
          primaryColor={token('color.icon.success')}
        />
      }
      appearance="normal"
      id={'UnlinkAccountSuccessFlag'}
      title={'Account removed'}
      description={"We've unlinked your account."}
      onDismissed={onDismiss}
    />
  );
};

export default UnlinkAccountSuccessFlag;
